
import { useState } from "react";
import { Link } from "react-router-dom";
import { useProjectByStorage } from "../projectData";

/**
 * ProfileDrawer component displays a side drawer with user profile and navigation links.
 * Includes privacy policy, terms, support, and redemption center options.
 */
export const ProfileDrawer = () => {
    const userData = JSON.parse(localStorage.getItem('cuslogin') || 'null');
    const projectData = useProjectByStorage();
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const drawerStyles = {
        position: 'fixed',
        top: 65,
        left: isDrawerOpen ? 0 : '-102%',
        width: '100%',
        height: '100%',
        // boxShadow: '-2px 0 5px rgba(0, 0, 0, 0.5)',
        //  transition: 'right 0.3s ease',
        zIndex: 1000,
    };
    const overlayStyles = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 999,
    };

    return (
        <>
            <div onClick={() => setIsDrawerOpen(!isDrawerOpen)} className="" >
                <i className="bi bi-list text-dark fw-semibolder fs-3x"></i>
            </div >
            <div className="card rounded-0 py-4 px-6" style={drawerStyles}>
                <div className=" d-flex justify-content-between align-items-center mt-8 px-6  pb-4 " >
                    <div>
                        <h3>{userData?.user?.first_name} {userData?.user?.last_name}</h3>
                        <div className="fw-normal fs-6">{userData?.user?.phone}</div>
                    </div>

                    <button
                        onClick={() => setIsDrawerOpen(!isDrawerOpen)}
                        type="button"
                        className="btn-close fw-semibold fs-4"
                        aria-label="Close"
                    ></button>
                </div>
                <div className="d-flex flex-column">
                    <Link to={'/customer/profile'}>
                        <div className="d-flex justify-content-between align-items-center mt-4 px-6 pb-4">
                            <div className="d-flex align-items-start  gap-4">
                                <i className="bi bi-person fs-2"></i>
                                <span className="fs-5 text-dark fw-normal">Profile </span>
                            </div>
                            <i className="bi bi-chevron-right"></i>
                        </div>
                    </Link>
                    <Link to={'/customer/redem-category'}>
                        <div className="d-flex justify-content-between align-items-center mt-4 px-6 pb-4">
                            <div className="d-flex align-items-start gap-4">
                                <i className="bi bi-gift fs-2"></i>
                                <span className="fs-5 text-dark fw-normal">Redemption Center</span>
                            </div>
                            <i className="bi bi-chevron-right"></i>
                        </div>
                    </Link>
                    {projectData?.pname !== 'greenply' && (
                        <>
                            <Link to={'/customer/page/privacy-policy'}>
                                <div className="d-flex justify-content-between align-items-center mt-4 px-6 pb-4">
                                    <div className="d-flex align-items-start gap-4">
                                        <i class="bi bi-shield-lock fs-2"></i>
                                        <span className="fs-5 text-dark fw-normal">Privacy Policy</span>
                                    </div>
                                    <i className="bi bi-chevron-right"></i>
                                </div>
                            </Link>
                            <Link to={'/customer/page/terms-condition'}>
                                <div className="d-flex justify-content-between align-items-center mt-4 px-6 pb-4">
                                    <div className="d-flex align-items-start gap-4">

                                        <i class="bi bi-file-text fs-2"></i>
                                        <span className="fs-5 text-dark fw-normal">Terms & Condition</span>
                                    </div>
                                    <i className="bi bi-chevron-right"></i>
                                </div>
                            </Link>
                            <Link to={'/customer/common-support'}>
                                <div className="d-flex justify-content-between align-items-center mt-4 px-6 pb-4">
                                    <div className="d-flex align-items-start gap-4">
                                        <i className="bi bi-person fs-2"></i>
                                        <span className="fs-5 text-dark fw-normal">Support </span>
                                    </div>
                                    <i className="bi bi-chevron-right"></i>
                                </div>
                            </Link>
                        </>
                    )}

                </div>
            </div >

            {isDrawerOpen && <div style={overlayStyles} onClick={() => setIsDrawerOpen(!isDrawerOpen)}></div>
            }
        </>
    );
};




